import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  padding: 2rem;
  img{
    background-color: black;
  }
  Table {
    background-color: white;
    color: black;
  }
  .ant-typography {
    color: black;
  }
  .ant-divider {
    background-color: black;
  }
  tr{
    background-color: white;
  }
  th{
    background-color: white;
  }
  thead{
    background-color: white;
  }

`;